import { EventButton } from "../../components/Button";
import Container from "../../styles/container";
import { TechList } from "../../components/TechList";
import { StyledDashboard, UserInfos, DashboardContent } from "./styles";
import StyledLogo from "../../components/Logo/styles";
import { motion } from "framer-motion";

import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import { Navigate } from "react-router-dom";

const Dashboard = () => {
  const { user, setShowModalLogout } = useContext(UserContext);

  return (
    <motion.div
      initial={{ opacity: 0, originY: 0.5 }}
      animate={{ opacity: 1, originY: 1 }}
      transition={{ duration: 0.5 }}
    >
      {user ? (
        <StyledDashboard>
          <header>
            <StyledLogo>Kenzie Hub</StyledLogo>
            <EventButton
              buttonSize={"small"}
              buttonStyle={"medium-style"}
              onClick={() => setShowModalLogout(true)}
              link=""
            >
              Sair
            </EventButton>
          </header>
          <UserInfos>
            <div>
              <h4>Olá, {user.name}</h4>
              <p>{user.course_module}</p>
            </div>
          </UserInfos>
          <Container>
            <DashboardContent>
              <TechList />
            </DashboardContent>
          </Container>
        </StyledDashboard>
      ) : (
        <Navigate to={"/"} />
      )}
    </motion.div>
  );
};

export default Dashboard;
